<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <defs>
      <clipPath id="master_svg0_363_24146">
        <rect x="0" y="0" width="12" height="12" rx="0" />
      </clipPath>
    </defs>
    <g
      style="mix-blend-mode: passthrough"
      clip-path="url(#master_svg0_363_24146)"
    >
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8.95334,2.5196212636108397C8.95334,2.5196212636108397,6.00021,5.47274926361084,6.00021,5.47274926361084C6.00021,5.47274926361084,3.047087,2.5196212636108397,3.047087,2.5196212636108397C2.9688369999999997,2.44937076361084,2.8809620000000002,2.41424586361084,2.783462,2.41424586361084C2.685962,2.41424586361084,2.599962,2.45137086361084,2.525462,2.52562126361084C2.4509616,2.5998712636108396,2.4138364,2.68587026361084,2.41408645,2.78362126361084C2.41433643,2.88137126361084,2.4494615,2.96924626361084,2.519462,3.0472462636108397C2.519462,3.0472462636108397,5.47259,6.00036926361084,5.47259,6.00036926361084C5.47259,6.00036926361084,2.519462,8.95349926361084,2.519462,8.95349926361084C2.4179615,9.05499926361084,2.3847116,9.17611926361084,2.4197115,9.31686926361084C2.4547116,9.45762926361084,2.540712,9.54549926361084,2.677712,9.58049926361084C2.814711,9.61549926361084,2.937712,9.58224926361084,3.046711,9.48074926361084C3.046711,9.48074926361084,5.99984,6.527619263610839,5.99984,6.527619263610839C5.99984,6.527619263610839,8.95297,9.48074926361084,8.95297,9.48074926361084C9.03121,9.55099926361084,9.11909,9.58611926361084,9.21659,9.58611926361084C9.31409,9.58611926361084,9.400089999999999,9.54899926361084,9.47459,9.474749263610839C9.54909,9.40049926361084,9.586210000000001,9.31449926361084,9.58597,9.21674926361084C9.585709999999999,9.118999263610839,9.55059,9.03111926361084,9.48059,8.95311926361084C9.48059,8.95311926361084,6.52746,5.99999926361084,6.52746,5.99999926361084C6.52746,5.99999926361084,9.48059,3.0468712636108397,9.48059,3.0468712636108397C9.58209,2.94537026361084,9.61534,2.8242452636108397,9.58034,2.6834962636108397C9.54534,2.54274626361084,9.457460000000001,2.45487086361084,9.31672,2.41987076361084C9.17596,2.38487086361084,9.05484,2.41812076361084,8.95334,2.5196212636108397C8.95334,2.5196212636108397,8.95334,2.5196212636108397,8.95334,2.5196212636108397C8.95334,2.5196212636108397,8.95334,2.5196212636108397,8.95334,2.5196212636108397Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SmallClose',
} as DefineComponent
</script>
